export default {
  technicalErrorTitle: 'Technical error',
  connectionErrorTitle: 'Connection problem',
  badRequest: 'Sorry, the request is invalid or incomplete.',
  serviceUnavailable: 'Sorry, the service is unavailable.',
  serviceUnavailableWithTime: 'Sorry, the service is unavailable. Please retry after',
  tooManyRequestError: 'Sorry, the service is unavailable.',
  tooManyRequestErrorWithTime: 'Sorry, the service is unavailable. Please retry after',
  sorry: 'Sorry',
  serverError: 'Sorry, there was a problem with the request.',
  networkError: 'Sorry, there seems to be a problem with your connection.',
  tryAgain: ' Please try again later.',
  okButton: 'OK',
  cancelButton: 'Cancel',
  retryButton: 'Retry',
};
